/**
 * Logs de diagnóstico Salesforce MC — prefixo único para filtrar no console.
 * Filtro sugerido: [Salesforce]
 */

const SF_TAG = "[Salesforce]";
const SF_STYLE_INFO = "color: #FF8C00; font-weight: bold;";
const SF_STYLE_OK = "color: #2E8B57; font-weight: bold;";
const SF_STYLE_WARN = "color: #FFA500; font-weight: bold;";
const SF_STYLE_ERROR = "color: #DC143C; font-weight: bold;";

export function maskSalesforceSecret(value?: string | null): string {
  if (!value) {
    return "(vazio)";
  }
  if (value.length <= 8) {
    return "***";
  }
  return `${value.slice(0, 4)}...${value.slice(-4)}`;
}

export function formatSalesforceError(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === "string") {
    return error;
  }
  try {
    return JSON.stringify(error);
  } catch {
    return String(error);
  }
}

export const sfLog = {
  info(message: string, details?: unknown): void {
    if (details !== undefined) {
      console.log(`%c${SF_TAG} ${message}`, SF_STYLE_INFO, details);
      return;
    }
    console.log(`%c${SF_TAG} ${message}`, SF_STYLE_INFO);
  },

  ok(message: string, details?: unknown): void {
    if (details !== undefined) {
      console.log(`%c${SF_TAG} ✓ ${message}`, SF_STYLE_OK, details);
      return;
    }
    console.log(`%c${SF_TAG} ✓ ${message}`, SF_STYLE_OK);
  },

  warn(message: string, details?: unknown): void {
    if (details !== undefined) {
      console.warn(`%c${SF_TAG} ⚠ ${message}`, SF_STYLE_WARN, details);
      return;
    }
    console.warn(`%c${SF_TAG} ⚠ ${message}`, SF_STYLE_WARN);
  },

  error(message: string, error?: unknown, details?: unknown): void {
    const payload = {
      erro: formatSalesforceError(error),
      ...(details !== undefined ? { detalhes: details } : {}),
    };
    console.error(`%c${SF_TAG} ✗ ${message}`, SF_STYLE_ERROR, payload, error);
  },
};
